import { Description, Field, Textarea, Label } from '@headlessui/react'
import React, { useState } from 'react'
import { cn } from '../../../../Utils/component'
import { ErrorMessage } from '../ErrorMessage'

interface TextAreaProps {
  description?: string
  label?: string
  disabled?: boolean
  placeholder?: string
  name: string
  required?: boolean
  value?: HTMLInputElement['value']
  // eslint-disable-next-line no-unused-vars
  onChange: (value: HTMLInputElement['value']) => void
  error?: string
  IconInput?: React.ReactNode
  autoComplete?: HTMLInputElement['autocomplete']
}

export const TextArea = (props: TextAreaProps) => {
  const {
    label,
    name,
    description,
    disabled = false,
    placeholder,
    required = false,
    value,
    onChange,
    error,
    IconInput,
    autoComplete = 'off',
  } = props
  const [isDirty, setIsDirty] = useState<boolean>(false)

  return (
    <Field disabled={disabled} aria-label={label} className={cn('space-y-2')}>
      {label && (
        <Label className="font-medium text-night text-sm/6">{label}</Label>
      )}
      {description && (
        <Description className="font-thin text-gray-500 text-sm/6">
          {description}
        </Description>
      )}

      <div className="relative">
        <Textarea
          {...props}
          id={name}
          name={name}
          disabled={disabled}
          data-invalid={Boolean(!isDirty || error)}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required={required}
          className={cn(
            'flex flex-row items-center w-full gap-2 p-3 px-3 bg-white border-2 border-gray-200 rounded-lg min-h-38 disabled:cursor-not-allowed placeholder:text-sm text-sm',
            Boolean(error) && 'border-red-300',
            Boolean(IconInput) && 'pl-10',
          )}
          value={value}
          onChange={(e) => {
            if (!isDirty) {
              setIsDirty(true)
            }
            if (onChange) onChange(e.target.value)
          }}
        />
      </div>
      {isDirty && <ErrorMessage error={error} />}
    </Field>
  )
}
